import { render, staticRenderFns } from "./CardSidebarTabDetails.vue?vue&type=template&id=1f76018f&scoped=true"
import script from "./CardSidebarTabDetails.vue?vue&type=script&lang=js"
export * from "./CardSidebarTabDetails.vue?vue&type=script&lang=js"
import style0 from "./CardSidebarTabDetails.vue?vue&type=style&index=0&id=1f76018f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f76018f",
  null
  
)

export default component.exports